<div class="flex flex-col gap-y-3.5">
  <div class="border border-neutral-500 rounded-md fit-content">
    <signature-pad
      [options]="signaturePadOptions"
      (drawEnd)="onSignatureDraw()"
      #signature></signature-pad>
  </div>
  <div class="w-[170px] self-end">
    <ui-button
      [outline]="true"
      (click)="clearSignature()"
      [disabled]="isDisabled()"
      >Clear Signature</ui-button
    >
  </div>
</div>
